import { render, staticRenderFns } from "./WorkInfo.vue?vue&type=template&id=f390b358&scoped=true"
import script from "./WorkInfo.vue?vue&type=script&lang=js"
export * from "./WorkInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkInfo.vue?vue&type=style&index=0&id=f390b358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f390b358",
  null
  
)

export default component.exports
import {QCard,QCardSection,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QImg})
